import { apiAxiosAuth } from 'services/api';
import { CollectionProps } from 'types/CollectionProps';
import { Product } from 'types/Product';

export async function searchCollection(
	wordToSearch: string,
	setListProducts: React.Dispatch<React.SetStateAction<CollectionProps[]>>,
	handleNotify: any
) {
	await apiAxiosAuth
		.get(`bridge/vtex/api/catalog_system/pvt/collection/search/${wordToSearch}`)
		.then((res) => {
			if (res.data.items) {
				setListProducts(res.data.items);
			} else {
				handleNotify(`Lista de coleção vázia para ${wordToSearch}`, 'info');
			}
		})
		.catch((error) => {
			handleNotify(
				error.message || 'Ocorreu algum erro aibuscar as coleções',
				'error'
			);
		});
}

interface GetProductBySKUResp {
	isSuccess: boolean;
	products: Product[];
}

export async function getProductBySKU(
	productoToSeach: number,
	handleNotify: any
) {
	const resp: GetProductBySKUResp = { isSuccess: false, products: [] };

	const queryString = encodeURIComponent(
		`?query=${productoToSeach}&page=1&count=10&sort=release:desc&hideUnavailableItems=true`
	);

	await apiAxiosAuth
		.get(`intelligent-autocomplete-products/${queryString}`)
		.then((response) => {
			if (response?.data?.products.length > 0) {
				resp.products = response?.data?.products || [];
				resp.isSuccess = true;
			} else {
				resp.products = [];
				resp.isSuccess = false;
				handleNotify('Nenhum produto encontrado', 'error');
			}
		})
		.catch((error) => {
			handleNotify(error?.message || '', 'error');
			resp.products = [];
			resp.isSuccess = false;
		});

	return resp;
}
